import script from "./RefUser.vue?vue&type=script&setup=true&lang=js"
export * from "./RefUser.vue?vue&type=script&setup=true&lang=js"

import "./RefUser.vue?vue&type=style&index=0&id=4561c28c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4561c28c"]])

export default __exports__